jQuery.noConflict();
(function( $ ) {
    $(function() {
        //Document Ready STARTS
        var rt = [];
        rt.loaded = false;
        $(window).on('load', function(){
            rtLoaded();
        });

        function rtLoaded() {
            if ($('.rating-wrap .to-rate').length>0) {

                $('body').on('click', '.to-rate > span', function(){
                    var score = $(this).attr('data-score'),
                        rated = $('.to-rate').attr('data-rated');
                    $('#post-rating input[name=rate]').val(score);
                    $('.to-rate').removeClass('rate-'+rated).addClass('rate-'+score).attr('data-rated', score);
                    $('.rating-wrap').addClass('clicked-on-rate');
                });

                $('body').on('mouseover', '.to-rate > span', function(){
                    var score = $(this).attr('data-score'),
                        rated = $('.to-rate').attr('data-rated');
                    $('#post-rating input[name=rate]').val(score);
                    $('.to-rate').removeClass('rate-'+rated).addClass('rate-'+score).attr('data-rated', score);
                });

                $('body').on('click', 'section', function(e){
                    if ($('.rating-wrap').hasClass('clicked-on-rate')) {
                       $('.rating-wrap').removeClass('clicked-on-rate');
                    }
                });

                $('#post-rating').on('submit', function(e){
                    e.preventDefault();
                    var rdata = $('#post-rating').serialize();
                    submitRateStarts(rdata);
                });
            }

            rt.loaded = true;
        }

        function submitRateStarts(rdata){
            $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'rate_event',
                    data: rdata
                }),

                beforeSend: function() {
                    $('.post-rating').addClass('submitting');
                },
                success: function( data ) {
                     $('.rating-wrap').html(data);
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        setTimeout(function(){
            if (rt.loaded == false) {
                rtLoaded();
            }
        }, 2500);

        //Document Ready ENDS
    });
})(jQuery);